<main class="auth">
	<div class="form">
		<div class="logo"></div>
		<acc-common-recover-password-form (onNavigateTo)="navigateTo($event)" (onRecover)="recover($event)"></acc-common-recover-password-form>
	</div>
</main>
